const DEFAULT_MAX_SIZE = 10000000;
const FILE_TYPES = ['JPG', 'PDF', 'PNG'];

const FILE_TYPES_TO_MIME_TYPES = {
  JPG: 'image/jpeg',
  PDF: 'application/pdf',
  PNG: 'image/png',
};

const MIME_TYPES_TO_FILE_TYPES = Object.fromEntries(
  Object.entries(FILE_TYPES_TO_MIME_TYPES).map(([key, value]) => [value, key]),
);

function fileTypes({ mimeTypes }) {
  return mimeTypes.map((mimeType) => MIME_TYPES_TO_FILE_TYPES[mimeType]);
}

function mimeTypes({ fileTypes }) {
  return fileTypes.map((fileType) => FILE_TYPES_TO_MIME_TYPES[fileType]);
}

export {
  DEFAULT_MAX_SIZE,
  FILE_TYPES,
  FILE_TYPES_TO_MIME_TYPES,
  fileTypes,
  mimeTypes,
};
